import { Box, Typography } from "@dealer-center/core-components";

export const LeadDistributionPage = () => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h6">Lead Distribution</Typography>
    <Typography sx={{ color: "text.secondary", mt: 1 }} variant="body-md">
      TODO: implement Lead Distribution
    </Typography>
  </Box>
);
